import { render, staticRenderFns } from "./DataTableCustom.vue?vue&type=template&id=24caf0e4"
import script from "./DataTableCustom.vue?vue&type=script&lang=js"
export * from "./DataTableCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports